/* unplugin-vue-components disabled */import { render } from "./thought.vue?vue&type=template&id=74e5cecc&scoped=true&ts=true"
import script from "./thought.vue?vue&type=script&lang=ts"
export * from "./thought.vue?vue&type=script&lang=ts"

import "./thought.vue?vue&type=style&index=0&id=74e5cecc&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e5cecc"]])

export default __exports__